/**
 * useFocusTrap — traps Tab/Shift+Tab focus inside a container.
 * Restores focus to the previously focused element on unmount.
 */

import { useEffect } from 'react';

const FOCUSABLE = 'a[href],button:not([disabled]),textarea,input,select,[tabindex]:not([tabindex="-1"])';

const useFocusTrap = (ref) => {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const prev = document.activeElement;
    const items = el.querySelectorAll(FOCUSABLE);
    if (items.length) items[0].focus();

    const handleTab = (e) => {
      if (e.key !== 'Tab') return;
      const focusable = [...el.querySelectorAll(FOCUSABLE)];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', handleTab);
    return () => {
      document.removeEventListener('keydown', handleTab);
      prev?.focus();
    };
  }, [ref]);
};

export default useFocusTrap;
